import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOnboardingStatus } from '../queries/onboarding';
import { useRetailAccounts as useRetailAccountsQuery } from '../queries/retailAccounts';
import { hasActivePortfolio } from '../hooks/useRetailAccounts';

const HomeRedirect = () => {
  const { user } = useAuth();

  const { data: onboarding, isPending: onboardingLoading } = useOnboardingStatus({ enabled: !!user });
  const { data: accounts = [], isPending: accountsLoading } = useRetailAccountsQuery({ enabled: !!user });

  if (!user) return <Navigate to="/login" replace />;
  if (onboardingLoading || accountsLoading) return null;

  if (!onboarding?.isComplete) return <Navigate to="/onboarding" replace />;

  if (hasActivePortfolio(accounts)) return <Navigate to="/portfolio" replace />;
  if (accounts.length > 0) return <Navigate to="/profile/portfolios" replace />;
  return <Navigate to="/onboarding" replace />;
};

export default HomeRedirect;
